// Module
var code = "<p> <label>radius</label> <input type=\"range\" min=\"0\" max=\"1\" step=\"0.01\" oninput=\"tetrahedron.p.radius.set(event.target.value)\"> </p> <p> <label>detail</label> <input type=\"range\" min=\"0\" max=\"10\" step=\"1\" oninput=\"tetrahedron.p.detail.set(event.target.value)\"> </p>";
// Exports
export default code;